import { InfoCircleOutlined } from "@ant-design/icons";
import { Col, Popover, Row, Typography } from "antd";
import React from "react";

const { Title, Text } = Typography;

//titles excluded from twitter note
const excluded = [
  'Percentage of News on Migration',
  'Porcentaje de noticias sobre migración',
  'Encuesta Mundial de Valores',
  'World Values Survey',
  'Latinobarómetro'
]

export default function DataboxTitleWithInfo(props) {
  return (
    <div style={{ width: "100%" }}>
      <Row gutter={36}>
        <Col span={props.metodologia ? 20 : 24}>
          <Title
            level={3}
            style={{ color: "var(--blue-primary)", textAlign: "left" }}
          >
            {props.title}
          </Title>
        </Col>
        {props.metodologia ? (
          <Col span={4} style={{ display: "flex", justifyContent: "end" }}>
            <Popover
              content={
                <div
                  style={{
                    width: "500px",
                    padding: "5px 16px 4px",
                  }}
                >
                  <Text>{props.metodologia}</Text>
                  {excluded.indexOf(props.title) === -1 && (
                    <div style={{marginTop: '20px'}}>
                        {props.language === 'en' ?
                          'Since the beginning of June 2023, the Laboratory is no longer using data from Twitter due to changes in the platform API access.' :
                          'Desde principios de junio de 2023, el Laboratorio ya no utiliza datos de Twitter debido a cambios en el acceso a la API de la plataforma.'
                        }
                    </div>
                  )}
                </div>
              }
              style={{ align: "right" }}
              title={props.language === "en" ? "Methodology" : "Metodología"}
              placement="leftTop"
            >
              <InfoCircleOutlined
                style={{
                  fontSize: "20px",
                  marginTop: "5px",
                  color: "var(--blue-primary)",
                  textAlign: "right",
                }}
              />
            </Popover>
          </Col>
        ) : null}
      </Row>
    </div>
  );
}
